import type { ReactNode } from "react";

/**
 * The surface treatment on its own, for a card that cannot be a `Card`.
 *
 * The pods list card is a `Link`, and wrapping a `Card` in one would nest two boxes. Applying the
 * class to the link keeps a single definition of what a card looks like.
 */
export const CARD_CLASS = "rounded-lg border border-border bg-surface";

interface CardProps {
  children: ReactNode;
  /** Padding and width are the caller's business; a card does not know how big it should be. */
  className?: string;
}

/** A raised surface: the app's one container treatment. */
export function Card({ children, className = "" }: CardProps) {
  return <div className={`${CARD_CLASS} ${className}`}>{children}</div>;
}
